//Draft Order 
const draft_order_button = document.getElementById('draft_product_order_form');

if (draft_order_button) {
    const cartdata = document.querySelector('.cartdata').value;
    const email = document.querySelector('.cartemail').value;
    const discountName = document.querySelector('.discountName').value;
    const discountPrice = document.querySelector('.discountPrice').value;
    document.getElementById('draft-order-form').addEventListener('submit', function(event) {
      event.preventDefault();
      const cartnote = document.querySelector('.cart__note textarea').value;
      const formData = new FormData();
      formData.append('cartdata', cartdata);
      formData.append('cartnote', cartnote);
      formData.append('customerid', email);
      formData.append('discountCode', discountName);
      formData.append('discountPrice', discountPrice);
      const loader = document.querySelector('.loader_option');
      loader.style.display = 'block'; 
      fetch(this.action, {
        method: 'POST',
        body: formData,
      })
      .then(response => response.json())
      .then(data => {
        if(data.status == 'success') {
          localStorage.setItem("cartStatus", "1");
          window.location.href = "https://kosta-boda-8586.myshopify.com/pages/net-orders-thank-you";
        } else {
          location.reload();
        }
      })
    });
}
